import React, {ReactNode, useEffect, useState, isValidElement, Children, ReactElement} from 'react';
import {Alert, Spinner, Row, Col, Stack, Badge, Card, Container} from 'react-bootstrap';
import ApiClientFactory from '../api/rest/template/TemplatesApiClientFactory';
import {ManifestDto} from '../api/rest/template/ManifestDto';

interface TemplatesListProps {
    children: ReactNode;
    manifests: ManifestDto[];
}

interface ActionsProps {
    children: (manifest: ManifestDto) => ReactNode;
}

const TemplatesList: React.FC<TemplatesListProps> & {Actions: React.FC<ActionsProps>} = ({children, manifests}) => {
    const actionComponent = Children.toArray(children).find((child) => isValidElement(child) && child.type === TemplatesList.Actions) as
        | ReactElement<ActionsProps>
        | undefined;
    const renderAction = actionComponent?.props.children;

    return (
        <Row>
            {manifests.map((t) => {
                return (
                    <Col sm={6} className={'mb-4'}>
                        <Card className="h-100 p-3" key={t.name + '-' + t.version}>
                            <Card.Body className={"py-2"}>
                                <div className="d-flex justify-content-between align-items-start ">
                                    <h4>{t.name}</h4>
                                    <Badge bg="info" className="fs--1">
                                        v{t.version}
                                    </Badge>
                                </div>
                                <div className="text-muted py-3">{t.description}</div>
                                <Stack direction="horizontal" gap={2} className="mt-1 flex-wrap mb-3">
                                    {t.tags.map((tag, idx) => (
                                        <Badge bg="secondary" key={idx}>
                                            {tag}
                                        </Badge>
                                    ))}
                                </Stack>
                                <div className={'text-muted justify-content-center'}>Last updated: asdfsdf</div>
                            </Card.Body>
                            <Card.Footer className={"py-2"}>
                                <div className={'d-flex gap-2'}>{renderAction ? renderAction(t) : null}</div>
                            </Card.Footer>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};
const Actions: React.FC<ActionsProps> = ({}) => {
    return null;
};

TemplatesList.Actions = Actions;

export default TemplatesList;
